import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITarihceList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITarihceList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  TarihceGoster: any[];
  TarihceGoster_dummy: any[];
  isComp85262Visible: "visible" | "hidden";
  isComp741471Enabled: "enabled" | "disabled";
  isComp739324Enabled: "enabled" | "disabled";
  isComp453852Enabled: "enabled" | "disabled";
  isComp79858Enabled: "enabled" | "disabled";
  isComptarihcelist_85262AuthorizationVisible: "visible" | "hidden";
  isComptarihcelist_321106AuthorizationVisible: "visible" | "hidden";
}

export class TarihceList_ScreenBase extends React.PureComponent<
  ITarihceList_ScreenProps,
  any
> {
  tarihcelist_739324_value_kuikaDatetimeRef: React.RefObject<any>;
  tarihcelist_79858_value_kuikaDatetimeRef: React.RefObject<any>;
  tarihcelist_603237_value_kuikaTableRef: React.RefObject<any>;
  tarihcelist_582178_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "8a32ca94-ad2f-418d-80f5-6bc4d407dff8",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 193594, PropertyName: "value", Value: "Kayıt Tarihçesi" },
        { Id: 183779, PropertyName: "value", Value: "Ekleyen" },
        { Id: 741471, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 542562, PropertyName: "value", Value: "Ekleme Zamanı" },
        {
          Id: 739324,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 978249, PropertyName: "value", Value: "Değiştiren" },
        { Id: 453852, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 608602, PropertyName: "value", Value: "Değiştirme Zamanı" },
        {
          Id: 79858,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 675691, PropertyName: "title", Value: "Zaman" },
        { Id: 711343, PropertyName: "value", Value: "[datafield:zaman]" },
        {
          Id: 582178,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 157643, PropertyName: "title", Value: "Kullanıcı" },
        { Id: 689377, PropertyName: "value", Value: "[datafield:kullanici]" },
        { Id: 361219, PropertyName: "title", Value: "Bilgi Grubu" },
        { Id: 820743, PropertyName: "value", Value: "[datafield:tablo]" },
        { Id: 962560, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 795512, PropertyName: "title", Value: "İşlem" },
        { Id: 835743, PropertyName: "value", Value: "[datafield:islem]" },
        { Id: 852716, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 664826, PropertyName: "title", Value: "Değişiklik" },
        { Id: 68711, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 85262, PropertyName: "title", Value: "." },
        { Id: 321106, PropertyName: "value", Value: "." },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.tarihcelist_741471_value_kuikaTextInputRef = React.createRef();
    this.tarihcelist_739324_value_kuikaDatetimeRef = React.createRef();
    this.tarihcelist_453852_value_kuikaTextInputRef = React.createRef();
    this.tarihcelist_79858_value_kuikaDatetimeRef = React.createRef();
    this.tarihcelist_603237_value_kuikaTableRef = React.createRef();
    this.tarihcelist_582178_value_kuikaDatetimeRef = React.createRef();
    this.tarihcelist_962560_value_kuikaTextInputRef = React.createRef();
    this.tarihcelist_852716_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      TarihceGoster: [],
      isComp85262Visible: "hidden",
      isComp741471Enabled: "disabled",
      isComp739324Enabled: "disabled",
      isComp453852Enabled: "disabled",
      isComp79858Enabled: "disabled",
      isComptarihcelist_85262AuthorizationVisible: "visible",
      isComptarihcelist_321106AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("tarihcelist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TarihceListPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarihcelist_85262AuthorizationVisible",
      ["41b245b2-8248-872c-382e-02ee2ce9c846", "FLYADMIN"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarihcelist_321106AuthorizationVisible",
      ["41b245b2-8248-872c-382e-02ee2ce9c846", "FLYADMIN"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("tarihcelist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("tarihcelist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TarihceListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      tarihcelist_741471_value:
        this.props.screenInputs.Ekleyen ?? this.props.screenInputs.ekleyen,
      tarihcelist_739324_value:
        this.props.screenInputs.EklemeZamani ??
        this.props.screenInputs.eklemezamani,
      tarihcelist_453852_value:
        this.props.screenInputs.Degistiren ??
        this.props.screenInputs.degistiren,
      tarihcelist_79858_value:
        this.props.screenInputs.DegistitirmeZamani ??
        this.props.screenInputs.degistitirmezamani,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TarihceListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      tablo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MasterTablo ??
          this.props.screenInputs.mastertablo,
        "string"
      ),
      id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MasterId ?? this.props.screenInputs.masterid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarihceList/TarihceListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TarihceGoster = result?.data.tarihceGoster;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TarihceListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarihceListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_603237 =
      stateVars.TarihceGoster ?? this.state.TarihceGoster;
    stateVars.isComp85262Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyUsername(),
        ReactSystemFunctions.convertToTypeByName("talu@", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TarihceListComponent_626264_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarihceListComponent_321106_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TarihceListPageInit();
    }
  }
}
